import classNames from "classnames"
import React from "react"

import ChevronRight from "../../../../assets/_V2/svg/ChevronRight"

import styles from "./styles.module.scss"

interface Props {
	className?: string // Класс
	data: {
		icon: JSX.Element // Иконка чата
		heading: string | JSX.Element // Заголовок
		textarea: string | JSX.Element // Описание
		social: {
			heading: string | JSX.Element // Заголовок
			textarea: string | JSX.Element // Описание
			url: string // Ссылка на соц сеть
		}
	}
}

// Компонент социальной сети
// Пример: /secret/ohmybowl
export default function SocialNetworkBanner(props: Props) {
	const data = props.data || {}
	return (
		<section className={classNames(styles.section, props.className)}>
			<div className={styles.banner}>
				<div className={styles.banner__row}>
					<div className={styles.banner__column}>
						<h2 className={styles.heading}>{data.heading}</h2>
						<p className={styles.textarea}>{data.textarea}</p>
					</div>
					<div className={styles.banner__column}>
						<a
							className={classNames(styles.socialNetwork)}
							href={data.social.url.href}
							target="_blank"
						>
							<div className={styles.socialNetwork__content}>
								{data.icon as JSX.Element}

								<div className={styles.socialNetwork__info}>
									<h3 className={styles.socialNetwork__headingContainer}>
										<span className={styles.socialNetwork__heading}>
											{data.social.heading}
										</span>

										<ChevronRight
											className={styles.socialNetwork__headingIcon}
										/>
									</h3>

									<p className={styles.socialNetwork__textarea}>
										{data.social.textarea}
									</p>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
		</section>
	)
}
